export default __webpack_public_path__ + "static/media/ulu 1.18cff472.png";